<template>
	<div class="relative">
		<button
			type="button"
			class="relative max-w-xs bg-white flex items-center rounded-full focus:text-orange"
			v-on:click.stop="open = !open"
		>
			<span class="sr-only">View notifications</span>
			<ui-icon
				class="mr-2 flex-shrink-0 h-5 w-5"
				name="bell"
				stroke-width="2"
			/>
			<span
				class="absolute top-0 right-0 inline-flex items-center justify-center px-2 py-1 text-xs font-bold leading-none text-orange-50 transform translate-x-1/4 -translate-y-1/2 bg-orange rounded-full"
				v-if="unreadCount > 0"
				>{{ unreadCount }}</span
			>
		</button>

		<div class="fixed inset-0 overflow-hidden" v-if="open">
			<div
				class="absolute inset-0"
				aria-hidden="true"
				ref="overlay"
				v-on:click.stop="close()"
			></div>
		</div>

		<transition name="zoomin">
			<div
				class="origin-top-right absolute right-0 mt-2"
				role="menu"
				aria-orientation="vertical"
				aria-labelledby="user-menu-button"
				tabindex="-1"
				v-if="open"
				ref="dropdown"
			>
				<div
					v-for="(notification, idx) in notifications"
					:key="'notification-' + idx"
					class="NOTmax-w-sm NOTw-full w-96 bg-white shadow-lg rounded-lg pointer-events-auto ring-1 ring-black ring-opacity-5 overflow-hidden z-10"
				>
					<!-- mt-2 w-48 rounded-md shadow-lg py-1 bg-white ring-1 ring-black ring-opacity-5 focus:outline-none -->
					<div class="p-4">
						<div class="flex items-start">
							<!-- <div class="flex-shrink-0">
                                <ui-icon class="h-6 w-6 text-gray-400" name="send" stroke-width="1.5" aria-hidden="true" />
                            </div>-->
							<div class="ml-3 w-0 flex-1 pt-0.5">
								<p class="font-medium text-gray-900">{{ notification.from }}</p>
								<p class="mt-1 text-gray-500">{{ notification.text }}</p>
								<div class="mt-3 flex space-x-7">
									<button
										class="bg-white rounded-md font-medium text-orange-500 hover:text-orange-400 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
										v-if="notification.link"
										v-on:click="$inertia.get(notification.link)"
									>
										Details
									</button>
								</div>
							</div>
							<div class="ml-4 flex-shrink-0 flex">
								<button
									@click="close()"
									class="bg-white rounded-md inline-flex text-gray-400 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-orange-500"
								>
									<span class="sr-only">Close</span>
									<ui-icon
										class="h-5 w-5"
										name="x"
										stroke-width="1.5"
										aria-hidden="true"
									/>
								</button>
							</div>
						</div>
					</div>
				</div>
			</div>
		</transition>
	</div>
</template>

<script>
import UiDropdown from "../Ui/Dropdown.vue";

export default {
	mixins: [UiDropdown],
	data() {
		return {
			xxxnotifications: [
				{
					from: "Landhandel Myerson",
					text: "Sie haben eine neue Offerte von Landhandel Myerson erhalten: 500 t B-Weizen Ab Station Willebadessen / 195,50 €/t.",
					actions: [
						{
							label: "Details",
							pageLink: "/test",
						},
					],
				},
			],
		};
	},
	computed: {
		notifications() {
			let that = this;
			return this.$inertia.page.props.unreadMessages.map(function (m) {
				return {
					from: m.counterpart.company_name,
					text:
						m.type == "BID" ? __("You have received a new offer!") : m.message,
					link: that.$route("threads", { active_id: m.thread_id }),
				};
			});
		},
		unreadCount() {
			return this.notifications.length;
		},
	},
};
</script>
